export enum PaymentRequestStatusEnum {
  CONFIRMED = <any>'confirmed',
  APPROVED = <any>'approved',
  REJECTED = <any>'rejected',
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/payment/payment-request-status.enum.ts